<template>
    <div :class="['edit-ranking']">
        <div :class="$style['edit-ranking-title']">修改</div>
        <wt-input-number v-model="crrentValue" :min="0"></wt-input-number>
        <div :class="$style['edit-ranking-button']">
            <el-button round type="primary" size="small" @click="sumitRank" :loading="loading">保存</el-button>
            <el-button round type="primary" plain size="small" @click="cancelEdit">取消</el-button>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    rowInfo: {
      type: Object,
      default: function () {
        return {}
      }
    },
    fromPage: String
  },
  data () {
    return {
      crrentValue: this.rowInfo.ranking,
      loading: false
    }
  },
  methods: {
    sumitRank () {
      let data = {
        goodsId: this.rowInfo.goodsId,
        ranking: this.crrentValue
      }
      this.loading = true
      let apiUrl = this.fromPage === 'integral' ? 'updateRankingOfIntegral':'updateRanking'
      this.$store.dispatch(apiUrl, data).then(res => {
        this.loading = false
        this.$emit('sumitRank')
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '修改推荐值失败')
      })
    },
    cancelEdit () {
      this.$emit('sumitRank')
    }
  }
}
</script>
<style module lang="less">
.edit-ranking-title{
    font-size: 15px;
    width: 100%;
    text-align: center;
    margin-bottom: 10px;
}
.edit-ranking-button{
    margin-top: 20px;
    display: flex;
    justify-content: space-between
}
</style>
